export const apportionmentTypeDictionary = {
	sales: 'Histórico de Vendas',
	consensus: 'Plano Irrestrito',
	collaboration: 'Plano da Colaboração de Comercial',
};
